import { useCallback } from 'react';

/**
 * Reads the permission set of whoever is currently PIN-identified on this till.
 *
 * The set is written by StaffPinGate on a successful PIN and comes straight from the server's
 * computed effective permissions (role template plus per-staff overrides) - the POS never derives
 * it from a role name, so a restaurant editing its Server role in the admin takes effect on the
 * next PIN entry without a POS release.
 *
 * Returns false when nobody is identified, which is the state the whole existing estate is in
 * today. Nothing gates on this yet; it exists so gates can be added one screen at a time.
 */
export default function usePermission() {
  const hasPermission = useCallback((key) => {
    try {
      const permissions = JSON.parse(localStorage.getItem('active_staff_permissions') || '[]');
      return permissions.includes(key);
    } catch {
      return false;
    }
  }, []);

  return hasPermission;
}
